import { useCallback, useEffect, useState } from 'react';

import { Job } from '~extension/web2print/model/Job';
import { DownloadModal } from '~extension/web2print/view/Download/DownloadModal';
import useDelayFn from '~hooks/useDelayFn';

export function DownloadModalController({ downloadJob, onClose }: { downloadJob: Job; onClose: () => void }) {
  const delayedOnClose = useDelayFn(onClose, 500);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  // open download modal if required parameters are given
  useEffect(() => {
    setIsOpen(Boolean(downloadJob));
  }, [downloadJob]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const handleOnClose = useCallback(() => {
    setIsOpen(false);
    delayedOnClose();
  }, [delayedOnClose]);

  return <DownloadModal downloadJob={downloadJob} isOpen={isOpen} onClose={handleOnClose} />;
}
